import * as actionTypes from './actionTypes';
import { I_Group } from './interfaces';
import dayjs from 'dayjs';

const initialState: I_Group = {
    ProductType: '',
    IsB2E: false,
    CreditCardUrl: '',
    CruiseRoomUrl: '',
    GoAirline: '',
    GoDepartureTime: '',
    GoArriveTime: '',
    GoDepartureAirport: '',
    GoArriveAirport: '',
    GoTransferCount: 1,
    BackAirline: '',
    BackDepartureTime: '',
    BackArriveTime: '',
    BackDepartureAirport: '',
    BackArriveAirport: '',
    BackTransferCount: 0,
    TourIndex: 0,
    CheckCruiseInfo: false,
    TelType: 0,
    IsNoFlight: false,
    IsPreview: false,
    IsEnsureGroup: false,
    GroupInfo: {
        TourID: '',
        TourName: '',
        NormGroupID: '',
        NormGroup: '',
        NormGroupImg: '',
        TourDays: 0,
        GoDate: '',
        BackDate: '',
        IsSleepless: false,
        Status: 0,
        StatusUrl: '',
        TotalSeats: 0,
        QuotaSeats: 0,
        SpareSeats: 0,
        IsBooked: false,
        IsEnsureGroup: false,
        IsForeign: false,
        TravelType: 0,
        ThemeID: [],
        AgeCalculation: '',
        StraightLowestPrice: 0,
        IndustryLowestPrice: 0,
        EnterLowestprise: 0,
        IsVip: false,
        VipOrigPrice: 0,
        ArriveID: '',
        MutiGroup: false,
        TourBu: '',
        TourBuName: '',
        KKSeats: 0,
        RegisteredSeats: 0,
        KeepSeats: 0,
        OBSeats: 0,
        GroupID: '',
        ActualSeats: 0,
        WaitSeats: 0,
        LevelID: 0,
        TagList: [],
        TripTypeList: [],
        Price: '',
        OrigPrice: '',
        StartFromCityList: [],
        CurrencyCode: '',
    },
    CalendarGroups: {
        isListMode: true,
        isLoadingCalendar: true,
        isGuaranteedDisabled: false,
        isGuaranteedChecked: false,
        parmIsEnsureGroup: false,
        month: dayjs().format('YYYY-MM'),
        groups: [],
    },
    todayMore: {
        GroupList: [],
    },
    FlightInfo: {
        GroupList: [],
    },
    StationInfoList: [],
    isHeaderShow: false,
    currentTourID: '',
    callJson: {
        BuName: '',
        Data: [],
    },
    scheduleActive: 0,
    isLoading: true,
    isSearchPanelFixed: false,
};

const groupReducer = (state: I_Group = initialState, action: any): I_Group => {
    switch (action.type) {
        case actionTypes.SET_GROUP:
            return { ...state, ...action.GroupInfo };
        case actionTypes.SET_ALLGROUP:
            return {
                ...state,
                CalendarGroups: { ...state.CalendarGroups, groups: action.allGroup },
            };
        case actionTypes.SET_PRICESINFO_SUCCESS:
            return { ...state, PricesInfo: action.payload };
        case actionTypes.SET_TODAYMORE_SUCCESS:
            return { ...state, todayMore: action.payload };
        case actionTypes.SET_GROUPALLTOURS_SUCCESS:
            return { ...state, Schedules: action.payload };
        case actionTypes.SET_GROUPDETAIL_SYNC:
        case actionTypes.SET_GROUPDETAIL_SUCCESS:
            return { ...state, ...action.payload };
        case actionTypes.SET_GROUPALLCALENDAR:
            return {
                ...state,
                CalendarGroups: { ...state.CalendarGroups, isLoadingCalendar: true },
            };
        case actionTypes.SET_GROUPALLCALENDAR_SUCCESS:
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    groups: action.payload,
                    isLoadingCalendar: false,
                },
            };
        case actionTypes.SET_CALENDARGROUPS_MODE: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isListMode: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_MONTH: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    month: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_GUARANTEED: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isGuaranteedDisabled: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_GUARANTEEDCHECKED: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    isGuaranteedChecked: action.payload,
                },
            };
        }
        case actionTypes.SET_CALENDARGROUPS_PARMISENSUREGROUP: {
            return {
                ...state,
                CalendarGroups: {
                    ...state.CalendarGroups,
                    parmIsEnsureGroup: action.payload,
                },
            };
        }
        case actionTypes.SET_STATIONINFO_SUCCESS:
            return { ...state, ...action.payload };
        // case actionTypes.SET_SKI_SUCCESS:
        //     return { ...state, Ski: action.payload };
        case actionTypes.SET_FLIGHTINFO_SUCCESS:
            return { ...state, FlightInfo: action.payload };
        case actionTypes.SET_ISHEADERSHOW:
            return { ...state, isHeaderShow: action.payload };
        case actionTypes.SET_CURRENTTOURID:
            return { ...state, currentTourID: action.payload };
        case actionTypes.SET_CALLJSON_SUCCESS:
            return { ...state, callJson: action.payload };
        case actionTypes.SET_SCHEDULESACTIVE:
            return { ...state, scheduleActive: action.payload };
        case actionTypes.SET_ISSEARCHPANELFIXED:
            return { ...state, isSearchPanelFixed: action.payload };
        default:
            return state;
    }
};

export default groupReducer;
